var React = require('react');

function Fb (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fb-logo .a{fill:#cdcdce;}")),React.createElement("path",{"className":"a","d":"M114.1,70.466V55.96h4.869l.729-5.653h-5.6V46.7c0-1.637.455-2.752,2.8-2.752h2.994V38.888a40.017,40.017,0,0,0-4.362-.223c-4.316,0-7.271,2.635-7.271,7.473v4.169h-4.882V55.96h4.882V70.466H114.1","transform":"translate(-103.376 -38.665)","key":1})]);
}

Fb.defaultProps = {"width":"16.515","height":"31.801","viewBox":"0 0 16.515 31.801","className":"fb-logo"};

module.exports = Fb;

Fb.default = Fb;
